import { Pipe, PipeTransform } from '@angular/core';

/**
 * Ensures a string is an absolute URL for use in href.
 * If the value does not start with a protocol (http://, https://, mailto:, tel:, etc.),
 * prepends https:// so the browser opens the link externally instead of as a relative path.
 */
@Pipe({
  name: 'externalUrl'
})
export class ExternalUrlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || typeof value !== 'string' || value.trim() === '') {
      return '';
    }
    const trimmed = value.trim();
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmed)) {
      return trimmed;
    }
    return 'https://' + trimmed;
  }
}
